export default __webpack_public_path__ + "static/media/calendar-icon.313ca6fc.svg";